<template>
    <div class="py-4" v-else>
        <div class="container">
            <div class="mx-auto col-md-12">
                <h1>Login</h1>
                <div class="alert" :class="'alert-'+message.type" v-if="message" v-text="message.text"></div>
                <form method="post" @submit.prevent="send">
                    <div class="form-group">
                        <label for="username">E-Mail</label>
                        <input type="email" class="form-control" id="username" v-model="username" required>
                    </div>
                    <div class="form-group">
                        <label for="password">Password</label>
                        <input type="password" v-model="password" id="password" class="form-control" required>
                    </div>
                    <button class="btn btn-primary">
                        <span v-if="isLoading"><i class="fa fa-spinner fa-spin fa-fw"></i></span>
                        <span v-else>Login</span>
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return {
      username: "",
      password: "",
      message: false,
      isLoading: false
    };
  },
  methods: {
    send() {
      this.isLoading = true;
      axios
        .post(loginUrl, {
          username: this.username,
          password: this.password
        })
        .then(({ data }) => {
          if (data.success) {
            store.dispatch("login");
            this.message = {
              type: "success",
              text: "Login successful"
            };
          } else {
            this.message = {
              type: "danger",
              text: data.error_description
            };
            setTimeout(() => (this.message = false), 3000);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/LoginForm.vue